import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Assignments from './pages/Assignments';
import Revision from './pages/Revision';
import Profile from './pages/Profile';
import LoadingScreen from './components/LoadingScreen';
import './App.css';

// Scroll to top component - improved
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force scroll to absolute top
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Also try document scroll
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if this is the first visit
    const hasVisited = localStorage.getItem('studyflow_visited');
    
    if (!hasVisited) {
      // First visit - show loading screen
      setIsLoading(true);
      
      const timer = setTimeout(() => {
        setIsLoading(false);
        // Mark as visited
        localStorage.setItem('studyflow_visited', 'true');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="revision" element={<Revision />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;